module.exports = __webpack_public_path__ + "img/csomagjaink__also_bg_768.39ffdb71.jpg";